

import EndPointConfig from "../../models/api/endPointConfig";

const controller = "Users";

export const UsersEP: EndPointConfig[] = [
    new EndPointConfig().setMethod('GET').setController(controller).setActionName('filtered').setAlias('GetUsersFiltered'),
    new EndPointConfig().setMethod('POST').setController(controller).setAlias('CreateUser'),
    new EndPointConfig().setMethod('PATCH').setPattern("{id}").setController(controller).setAlias('UpdateUser'),
];

